import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const Show = () => {
  const [receiveData, setReceiveData] = useState([]);
  const { id } = useParams();

  const fetchData = useCallback(() => {
    Http.get("/journal-voucher/" + id).then((res) => {
      setReceiveData(res.data);
    });
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const print = () => {
    window.print();
  };



  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Journal Voucher Detail</h5>
          </div>
          <style>
            {`
              @media print {
                  body * { visibility: hidden; font-size:10px;}
                  .no-print { visibility: hidden !important; }
                  #printable-content, #printable-content * { visibility: visible; }
                  #printable-content { position: absolute; left: 0; top: 0; width: 100%; }
                  .main-card { padding: 0px; }
                  .am-pagebody { padding: 0px; }
                  .am-mainpanel { margin-top: 0px; }
                  .signature_section .table td{ border-bottom: 0;}
              }
              .main-card { padding: 40px; }
            `}
          </style>
          <div className="am-pagebody">
            <div className="row mt-3">
                <div className="col-md-12 text-right">
                    <button className="no-print btn btn-sm btn-info" onClick={print}>
                    🖨 Print
                    </button>
                </div>
            </div>
            <div className="card main-card mt-3">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 padding">
                <div className="card" id="printable-content">
                  <div className="row">
                    <div className="col-md-12">
                      <table className="table" width="100%">
                        <tbody>
                          <tr>
                            {/* <td width="20%">
                              <img src="/limtech-logo.png" alt="Limerick Logo" style={{height: '60px'}} />
                            </td> */}
                            <td width="80%" align="center">
                              <h3 style={{margin: '0', color: '#1f4e79'}}>Ideal Textile Limited</h3>
                              <h5 className="text-bold" style={{margin: '5px 0'}}>Journal Voucher</h5>
                            </td>
                            <td width="20%" align="right">
                              <strong>Journal No : {receiveData.serial_number}</strong><br/>
                              <strong>Date : {receiveData.date}</strong><br/>
                              <strong>Journal Code : {receiveData.journal_code || ''}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <table className="table table-bordered" width="100%" style={{marginBottom: '20px'}}>
                        <thead style={{backgroundColor: '#f8f9fa'}}>
                          <tr>
                            <th style={{width: '15%', textAlign: 'center', padding: '8px'}}>Acc-Code</th>
                            <th style={{width: '40%', textAlign: 'center', padding: '8px'}}>Head Of Accounts</th>
                            <th style={{width: '15%', textAlign: 'center', padding: '8px'}}>Dr</th>
                            <th style={{width: '15%', textAlign: 'center', padding: '8px'}}>Cr</th>
                            <th style={{width: '15%', textAlign: 'center', padding: '8px'}}>Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                          {receiveData.items
                            ? receiveData.items.map((item, index) => (
                                <tr key={item.id}>
                                  <td style={{textAlign: 'center', padding: '8px'}}>
                                    {item.chart_of_account ? item.chart_of_account.code : ''}
                                  </td>
                                  <td style={{padding: '8px'}}>
                                    {item.chart_of_account ? item.chart_of_account.name : ''}
                                    {item.distributor && (
                                      <div style={{fontSize: '12px', color: '#666'}}>
                                        {item.distributor.name}
                                      </div>
                                    )}
                                  </td>
                                  <td style={{textAlign: 'right', padding: '8px'}}>
                                    {parseFloat(item.debit) > 0 ? parseFloat(item.debit).toFixed(2) : ''}
                                  </td>
                                  <td style={{textAlign: 'right', padding: '8px'}}>
                                    {parseFloat(item.credit) > 0 ? parseFloat(item.credit).toFixed(2) : ''}
                                  </td>
                                  <td style={{textAlign: 'center', padding: '8px'}}></td>
                                </tr>
                              ))
                            : ""}

                          <tr style={{backgroundColor: '#f8f9fa', fontWeight: 'bold'}}>
                            <td colSpan="2" style={{textAlign: 'center', padding: '8px'}}>
                              <strong>Total Amount</strong>
                            </td>
                            <td style={{textAlign: 'right', padding: '8px'}}>
                              <strong>{receiveData.total_amount}</strong>
                            </td>
                            <td style={{textAlign: 'right', padding: '8px'}}>
                              <strong>{receiveData.total_amount}</strong>
                            </td>
                            <td style={{textAlign: 'center', padding: '8px'}}></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* <div className="row mt-4">
                    <div className="col-md-12">
                      <h5 style={{textAlign: 'center', marginBottom: '15px', textDecoration: 'underline'}}>
                        Details Transaction
                      </h5>
                      <table className="table table-bordered" width="100%">
                        <thead style={{backgroundColor: '#f8f9fa'}}>
                          <tr>
                            <th style={{textAlign: 'center', padding: '8px'}}>Ledger</th>
                            <th style={{textAlign: 'center', padding: '8px'}}>Subsidiary Ledger</th>
                            <th style={{textAlign: 'center', padding: '8px'}}>Bill No</th>
                            <th style={{textAlign: 'center', padding: '8px'}}>Bill Date</th>
                            <th style={{textAlign: 'center', padding: '8px'}}>Debit</th>
                            <th style={{textAlign: 'center', padding: '8px'}}>Credit</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{padding: '20px'}}>&nbsp;</td>
                            <td style={{padding: '20px'}}>&nbsp;</td>
                            <td style={{padding: '20px'}}>&nbsp;</td>
                            <td style={{padding: '20px'}}>&nbsp;</td>
                            <td style={{padding: '20px'}}>&nbsp;</td>
                            <td style={{padding: '20px'}}>&nbsp;</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> */}

                  <div className="row mt-3">
                    <div className="col-md-12">
                      <p style={{margin: '10px 0'}}>
                        <strong>Narration : </strong>{receiveData.remarks}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
